<template>
  <div id="app">
    <!-- <router-link to="/"></router-link> | -->
    <!-- <router-view /> -->
    <Home />
  </div>
</template>

<script>
import Home from './views/Home.vue'
export default {
  name: 'App',
  components: {
    Home
  }
 
}
</script>

<style lang="scss">

</style>
